import { render, staticRenderFns } from "./ModalNewTransportVenhicle.vue?vue&type=template&id=8fc3b752&scoped=true&"
import script from "./ModalNewTransportVenhicle.vue?vue&type=script&lang=js&"
export * from "./ModalNewTransportVenhicle.vue?vue&type=script&lang=js&"
import style0 from "./ModalNewTransportVenhicle.vue?vue&type=style&index=0&id=8fc3b752&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fc3b752",
  null
  
)

export default component.exports